import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Checkbox } from './ui/checkbox';

interface MarkdownRendererProps {
  content: string;
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content }) => {
  return (
    <div className="prose max-w-none text-base leading-relaxed md:prose-lg">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({node, children, ...props}) => <h1 className="text-2xl font-bold mb-4" {...props}>{children}</h1>,
          h2: ({node, children, ...props}) => <h2 className="text-xl font-bold mb-3" {...props}>{children}</h2>,
          h3: ({node, children, ...props}) => <h3 className="text-lg font-bold mb-2" {...props}>{children}</h3>,
          p: ({node, children, ...props}) => <p className="mb-4" {...props}>{children}</p>,
          ul: ({node, children, ...props}) => <ul className="list-disc list-inside mb-4" {...props}>{children}</ul>,
          ol: ({node, children, ...props}) => <ol className="list-decimal list-inside mb-4" {...props}>{children}</ol>,
          li: ({node, children, ...props}) => <li className="mb-2" {...props}>{children}</li>,
          blockquote: ({node, children, ...props}) => <blockquote className="border-l-4 border-muted-foreground pl-4 italic my-4" {...props}>{children}</blockquote>,
          input: ({node, ...props}) => {
            if (props.type === 'checkbox') {
              return <Checkbox checked={props.checked} disabled={props.disabled} className="mr-2" />;
            }
            return <input {...props} />;
          },
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
